<template>
  <v-main>
    <v-container fluid>
      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-title>
              <h3 class="font-weight-bold">Franchise Staff</h3>
              <v-btn v-can:add="['franchisee_staffs', 'my_staff']"
                class="mx-2 mb-2 hover-primary"
                fab
                small
                color="primary"
                :to="
                  this.$route.query.franchisee_id
                    ? `/franchisee-staffs/create?franchisee_id=${this.$route.query.franchisee_id}`
                    : `/franchisee-staffs/create`
                "
              >
                <v-icon dark> mdi-plus </v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col lg="4" md="6" sm="12" cols="12">
                  <v-text-field
                    solo
                    rounded
                    hide-details="auto"
                    v-model="filter.search_keyword"
                    label="Search by name, email, phone..."
                    prepend-inner-icon="mdi-magnify"
                    clearable
                    @click:clear="
                      (filter.search_keyword = null), (page = 1), getData()
                    "
                    @keydown.enter="(page = 1), getData()"
                  ></v-text-field>
                </v-col>
                <!-- <v-col lg="3" md="3" sm="4" cols="12">
                  <v-autocomplete
                    solo
                    hide-details="auto"
                    rounded
                    v-model="filter.position_id"
                    :items="positionItems"
                    label="Position"
                    placeholder="Filter by Position"
                    @input="(page = 1), getData()"
                    prepend-inner-icon="mdi-account-tie-outline"
                    clearable
                  ></v-autocomplete>
                </v-col> -->
                <v-col
                  lg="3"
                  md="3"
                  sm="4"
                  cols="12"
                  v-if="!this.$route.query.franchisee_id"
                >
                  <v-autocomplete
                    solo
                    hide-details="auto"
                    rounded
                    v-model="filter.franchisee_id"
                    :items="franchiseeItems"
                    label="Franchisee"
                    placeholder="Filter by Franchisee"
                    @input="(page = 1), getData()"
                    prepend-inner-icon="mdi-store"
                    clearable
                  ></v-autocomplete>
                </v-col>
                <v-col lg="2" md="3" sm="4" cols="12">
                  <v-autocomplete
                    solo
                    hide-details="auto"
                    rounded
                    v-model="filter.is_active"
                    :items="statusItems"
                    label="Status"
                    @input="(page = 1), getData()"
                    placeholder="Filter by Status"
                    prepend-inner-icon="mdi-toggle-switch"
                    clearable
                  ></v-autocomplete>
                </v-col>
                <v-col lg="2" md="3" sm="4" cols="12">
                  <v-autocomplete
                    solo
                    hide-details="auto"
                    rounded
                    v-model="filter.is_kyc_verified"
                    :items="kycStatusItems"
                    label="KYC Status"
                    @input="(page = 1), getData()"
                    @click:clear="(filter.is_kyc_verified = ''), (page = 1), getData()"
                    placeholder="Filter by KYC Status"
                    prepend-inner-icon="mdi-checkbox-marked-circle"
                    clearable
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-text>
              <section v-if="isLoading" style="height: 575px">
                <v-progress-linear
                  indeterminate
                  color="primary"
                ></v-progress-linear>
              </section>
              <v-simple-table
                v-else
                fixed-header
                height="575"
                class="striped-table"
              >
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">Sr No</th>
                      <th class="text-left">Status</th>
                      <th class="text-left">Approval Status</th>
                      <th class="text-left">KYC Status</th>
                      <th class="text-left">Name</th>
                      <th class="text-left">Email</th>
                      <th class="text-left">Phone</th>
                      <th class="text-left">Position</th>
                      <th class="text-left">Franchisee</th>
                      <th class="text-left">Employee Code</th>
                      <th class="text-left">Created At</th>
                      <th class="text-right action_th">Action</th>
                    </tr>
                  </thead>
                  <tbody v-if="staffs.length != 0">
                    <tr v-for="(staff, i) in staffs" :key="`staff${i}`">
                      <td style="min-width: 85px">
                        {{ serialNoStarting + i + 1 }}
                      </td>
                      <td>
                        <v-chip
                          small
                          :color="staff.is_active == 1 ? 'teal' : 'red'"
                          text-color="white"
                        >
                          <v-avatar left>
                            <v-icon size="15">
                              {{
                                staff.is_active == 1
                                  ? "mdi-checkbox-marked-circle"
                                  : "mdi-close-circle"
                              }}
                            </v-icon>
                          </v-avatar>
                          {{ staff.is_active == 1 ? "Active" : "Inactive" }}
                        </v-chip>
                      </td>
                      <td>
                        <v-tooltip bottom v-if="staff.career_request_status == 1">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="teal"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15"
                                  >mdi-checkbox-marked-circle</v-icon
                                >
                              </v-avatar>
                              Approved
                            </v-chip>
                          </template>
                          <span>{{ careerTypeLabel(staff) }} application approved</span>
                        </v-tooltip>
                        <v-tooltip bottom v-else-if="staff.career_request_status == 2">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="red"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15">mdi-close-circle</v-icon>
                              </v-avatar>
                              Rejected
                            </v-chip>
                          </template>
                          <span>{{ careerTypeLabel(staff) }} application rejected</span>
                        </v-tooltip>
                        <v-tooltip bottom v-else-if="staff.career_request_status == 0">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="yellow"
                              text-color="black"
                            >
                              <v-avatar left>
                                <v-icon size="15">mdi-clock-outline</v-icon>
                              </v-avatar>
                              Pending
                            </v-chip>
                          </template>
                          <span>{{ careerTypeLabel(staff) }} application is still under review</span>
                        </v-tooltip>
                        <v-tooltip bottom v-else>
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="blue-grey lighten-4"
                              text-color="black"
                            >
                              <v-avatar left>
                                <v-icon size="15">mdi-account-plus</v-icon>
                              </v-avatar>
                              Direct
                            </v-chip>
                          </template>
                          <span>Added from the portal - no career application</span>
                        </v-tooltip>
                      </td>
                      <td>
                        <v-tooltip bottom v-if="staff.is_kyc_verified == 1">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="teal"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15"
                                  >mdi-checkbox-marked-circle</v-icon
                                >
                              </v-avatar>
                              Verified
                            </v-chip>
                          </template>
                          <span>KYC verified - this walker can be assigned jobs</span>
                        </v-tooltip>
                        <v-tooltip bottom v-else-if="staff.is_kyc_verified == 2">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="red"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15">mdi-close-circle</v-icon>
                              </v-avatar>
                              Rejected
                            </v-chip>
                          </template>
                          <span>A KYC document was rejected - the walker must re-submit</span>
                        </v-tooltip>
                        <v-tooltip bottom v-else>
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="yellow"
                              text-color="black"
                            >
                              <v-avatar left>
                                <v-icon size="15">mdi-clock-outline</v-icon>
                              </v-avatar>
                              Pending
                            </v-chip>
                          </template>
                          <span>KYC pending - no job can be assigned until it is verified</span>
                        </v-tooltip>
                      </td>
                      <td>
                        {{ staff.first_name }} {{ staff.middle_name }}
                        {{ staff.last_name }}
                      </td>
                      <td>{{ staff.email || "" }}</td>
                      <td>{{ staff.phone || "" }}</td>
                      <td>{{ staff.position ? staff.position.name : "" }}</td>
                      <td>
                        {{ staff.franchisee ? staff.franchisee.name : "" }}
                      </td>
                      <td>{{ staff.employee_code || "" }}</td>
                      <td style="min-width: 160px">{{ formatDate(staff.created_at) }}</td>
                      <td class="text-right" style="min-width: 195px">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              v-bind="attrs"
                              v-on="on"
                              fab
                              x-small
                              class="my-auto"
                              color="info"
                              :to="`/user-kyc-documents?user_id=${encryptIt(staff.id)}`"
                            >
                              <v-icon dark> mdi-file-document </v-icon>
                            </v-btn>
                          </template>
                          <span>View KYC Documents</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              v-bind="attrs"
                              v-on="on"
                              class="ml-2"
                              fab
                              x-small
                              color="primary"
                              :to="`/franchisee-staffs/${encryptIt(staff.id)}`"
                            >
                              <v-icon dark> mdi-pencil </v-icon>
                            </v-btn>
                          </template>
                          <span>Edit this staff</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn v-can:delete="['franchisee_staffs', 'my_staff']"
                              v-bind="attrs"
                              v-on="on"
                              class="ml-2"
                              fab
                              x-small
                              color="error"
                              @click="deleteStaff(staff.id)"
                            >
                              <v-icon dark> mdi-delete </v-icon>
                            </v-btn>
                          </template>
                          <span>Delete this staff</span>
                        </v-tooltip>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td colspan="12" class="text-center">No staff found</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <v-row class="mt-4">
                <v-col
                  cols="12"
                  class="d-flex justify-space-between align-center"
                >
                  <v-pagination v-model="page" :length="paginationLength">
                  </v-pagination>
                  <v-select
                    v-model="itemsPerPage"
                    :items="rowsPerPageOptions"
                    label="Rows per page"
                    dense
                    outlined
                    hide-details
                    @change="onRowsPerPageChange"
                    style="max-width: 150px"
                  ></v-select>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";

export default {
  name: "FranchiseeStaffIndexPage",
  data() {
    return {
      filter: {
        search_keyword: "",
        position_id: "",
        franchisee_id: "",
        is_active: "",
        is_kyc_verified: "",
      },
      page: 1,
      itemsPerPage: 10,
      rowsPerPageOptions: [
        { text: "10", value: 10 },
        { text: "15", value: 15 },
        { text: "20", value: 20 },
        { text: "25", value: 25 },
        { text: "50", value: 50 },
        { text: "ALL", value: -1 },
      ],
      serialNoStarting: 1,
      paginationLength: 0,
      count: 0,
      staffs: [],
      positionItems: [],
      franchiseeItems: [],
      statusItems: [
        { id: "ACTIVE", text: "ACTIVE", value: "1" },
        { id: "INACTIVE", text: "INACTIVE", value: "0" },
      ],
      // Mirrors users.is_kyc_verified: 0 pending, 1 verified, 2 rejected.
      kycStatusItems: [
        { id: "VERIFIED", text: "VERIFIED", value: "1" },
        { id: "PENDING", text: "PENDING", value: "0" },
        { id: "REJECTED", text: "REJECTED", value: "2" },
      ],
      isLoading: false,
    };
  },
  watch: {
    page: "getData",
    "$route.query.franchisee_id": "getData",
  },
  mounted() {
    if (this.$route.query.franchisee_id) {
      this.filter.franchisee_id = parseInt(
        this.decryptIt(this.$route.query.franchisee_id)
      );
    }
    this.getMasters();
  },
  methods: {
    // career_type comes from the listing: WALKIE / TRAINER / DAYCARE / FRANCHISEE.
    careerTypeLabel(staff) {
      const labels = {
        WALKIE: "Walkie",
        TRAINER: "Pet Trainer",
        DAYCARE: "Day Care",
        FRANCHISEE: "Franchisee",
      };
      return labels[staff.career_type] || "Career";
    },
    formatDate(value) {
      if (!value) return "";
      try {
        const d = new Date(value);
        const pad = (n) => String(n).padStart(2, "0");
        const day = pad(d.getDate());
        const month = pad(d.getMonth() + 1);
        const year = d.getFullYear();
        const hours = pad(d.getHours());
        const minutes = pad(d.getMinutes());
        const seconds = pad(d.getSeconds());
        return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
      } catch (e) {
        return value;
      }
    },
    async getMasters() {
      try {
        const response = await axios.get(
          `masters?context=user&franchise_kyc=1&franchisee_status=1`
        );
        const masters = response.data;

        // Load positions (only Franchisee Staff and Franchisee Admin)
        masters.positions.forEach((position) => {
          if (
            position.name === "FRANCHISEE STAFF" ||
            position.name === "FRANCHISEE ADMIN"
          ) {
            this.positionItems.push({
              id: position.id,
              text: position.name,
              value: position.id,
            });
          }
        });

        // Set default position filter
        const franchiseeStaffPosition = this.positionItems.find(
          (p) => p.text === "FRANCHISEE STAFF"
        );
        const franchiseeAdminPosition = this.positionItems.find(
          (p) => p.text === "FRANCHISEE ADMIN"
        );

        const positionIds = [];
        if (franchiseeStaffPosition)
          positionIds.push(franchiseeStaffPosition.id);
        if (franchiseeAdminPosition)
          positionIds.push(franchiseeAdminPosition.id);

        if (positionIds.length > 0) {
          this.filter.position_id = positionIds.join(",");
        }

        // Load franchisees
        masters.franchisees.forEach((franchisee) => {
          this.franchiseeItems.push({
            id: franchisee.id,
            text: franchisee.name,
            value: franchisee.id,
          });
        });

        await this.getData();
      } catch (error) {
        console.error("Error loading masters:", error);
        this.isUnAuthorised();
      }
    },

    async getData() {
      this.isLoading = true;

      const actualRowsPerPage =
        this.itemsPerPage === -1 ? 1000000 : this.itemsPerPage;

      const query = `page=${this.page}&rowsPerPage=${actualRowsPerPage}&is_active=${this.filter.is_active}&position_id=3&franchisee_id=${this.filter.franchisee_id}&search_keyword=${this.filter.search_keyword}&is_kyc_verified=${this.filter.is_kyc_verified}`;

      try {
        const response = await axios.get(`users?${query}`);
        this.staffs = response.data.data || [];
        this.count = response.data.count || 0;

        this.serialNoStarting =
          this.itemsPerPage === -1 ? 0 : (this.page - 1) * this.itemsPerPage;

        if (this.itemsPerPage === -1) {
          this.paginationLength = 1;
        } else {
          this.paginationLength = Math.ceil(this.count / this.itemsPerPage);
        }
      } catch (error) {
        console.error("Error fetching staffs:", error);
        this.staffs = [];
        this.count = 0;
        this.isUnAuthorised();
      }

      this.isLoading = false;
    },

    onRowsPerPageChange() {
      this.page = 1;
      this.getData();
    },

    async deleteStaff(id) {
      if (confirm("Are you sure you want to delete this staff member?")) {
        try {
          await axios.post(`/users/delete/${this.encryptIt(id)}`);
          this.isShowPopUP("Success", "Staff deleted successfully", "success");
          this.getData();
        } catch (error) {
          console.error("Error deleting staff:", error);
          this.isUnAuthorised();
        }
      }
    },
  },
};
</script>

<style scoped>
.striped-table tbody tr:nth-child(odd) {
  background-color: #f5f5f5;
}
</style>
